import { FC, useEffect, useState } from 'react';

import { Encumbrance } from 'types';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import DocumentsTable from 'modules/documents/components/DocumentsTable';

import { useGetDocuments } from 'modules/_shared/hooks/useGetDocuments';

type Props = {
  encumbrances: Encumbrance[];
};

const ShareEncumbranceDocumentsView: FC<Props> = ({ encumbrances }) => {
  const [documentIds, setDocumentIds] = useState<string[]>([]);

  const useGetDocumentsResult = useGetDocuments({ documentIds });

  const { documents } = useGetDocumentsResult.data;
  const { isLoading } = useGetDocumentsResult;

  useEffect(() => {
    const documentIds = encumbrances
      .flatMap((encumbrance) => encumbrance.scriptureDocument)
      .filter((document) => document);

    setDocumentIds(documentIds);
  }, [encumbrances]);

  return (
    <>
      <DocumentsTable documents={documents} />
      {isLoading && <CustomLoading />}
    </>
  );
};

export default ShareEncumbranceDocumentsView;
